export const useMultiPhoneSupport = () => {
  const hasMultiPhoneSupport = true
  const phoneNumberOptions: Record<number, { displayName: string }> = {}
  const maxPhones = 16

  phoneNumberOptions[0] = { displayName: "Random" }

  for (let i = 1; i <= maxPhones; i++) {
    phoneNumberOptions[i] = { displayName: `Phone Number ${i}` }
  }

  return {
    hasMultiPhoneSupport,
    phoneNumberOptions,
  }
}
